export const landingPage = {
    template1: {
        btnMessage1: '拆除改造',
        btnMessage2: '水电改造',
        btnMessage3: '瓦工',
        btnMessage4: '木工',
        btnMessage5: '油工',
        btnMessage6: '安装工程',
        btnMessage7: '保洁完工',
        message1: '湖北.宜都西湖尚苑B区别墅',
        message2: '科学施工·进度透明',
        message3: '遵循业内工艺标准，全力打造理想住宅',
        message4: '移动互联时代新体验',
        message5: '率先推出协同施工 新技术革命助推家装行业变革',
        message6: '实时同步施工动态',
        message7:
            '施工节点清晰完整，图片视频语音文字多种形式，足不出户无忧沟通，实时有反馈，施工有保障',
        message8: '案例效果图',
        message9: '黄小宝设计研发中心',
        message10:
            '黄小宝设计研究中心，致力于学术研究。部分社会荣誉：福建省室内装饰装修协会副会长、福州市长泰商会 副会长，特邀编写《2007.10及11月金版装潢世界》《2008年经典家居》前言； 《2019室内设计与施工节点手册》主编；《2020年福建省住宅室内装饰工程质量标准》 起草人；2017年荣获“光华龙腾奖”中国装饰设计业十大杰出青年百人榜金牌、2018年海西创意设计杰出贡献奖、2019年福建省室内设计精英人物。',
    },
    template2: {
        message1: '金辉铂宫',
        message2: '高效协同·实时共享',
        message3: '施工信息高效协同，减少沟通成本，信息无缝同步',
        message4: '福昕家装云服务',
        message5: '传统做法及劣势',
        message6: '案例效果图',
        message7: '福州集致空间装饰',
        message8:
            '福州集致空间设计是一家专业从事整木定制、软装配套服务的设计公司。提供橱衣柜、酒窖酒柜、护墙板、木门等定制服务以及软装家具设计配套，作为全屋定制生产公司，集致空间设计为用户提供“从设计到用材、生产到运输、从安装到售后”的整体服务。公司始终坚持以产品以及服务品质为立足之本，始终坚持客户利益最大化，深得客户信赖与厚爱，以服务赢得市场美誉。',
        message9: '多角色360°信息互通',
        message10: '项目多角色管理，基于不同权限分工，信息流通更顺畅',
    },
    aboutFoxit: {
        message1: '国际PDF协会主要成员',
        message2:
            '主要成员中唯一一家中国公司。多年来参与了多项国际标准的制定、维护和实现工作。',
        message3: '中国建筑装饰协会会员',
        message4:
            '福昕家装秉承生态共享，在资源、产品、技术合作等领域实现深度融合，助力建筑装饰行业快速发展。',
        message5: '中国版式文档OFD标准制定成员',
        message6:
            '参与PDF国际标准、国家标准制定，是中国唯一一家双重支持国际、国内标准的版式电子文档软件厂商。',
        message7: '关于福昕',
        message8:
            '福建福昕软件开发股份有限公司是一家国际化运营的PDF电子文档解决方案提供厂商，是国际PDF协会主要成员、中国版式文档OFD标准制定成员。福昕在亚洲、美洲、欧洲和澳洲设有多家子公司，福昕直接用户已超过',
        message9: '亿，企业客户数达',
        message10: '万以上，遍及世界',
        message11: '多个国家和地区。',
    },
    intelligentDesign: {
        message1: '费用无忧',
        message2: '灵活支付 ，免费升级',
        message3: '上手无忧',
        message4: '半天学会，一天超神',
        message5: '效率无忧',
        message6: '无需网络，海量真实素材',
        message7: '资产无忧',
        message8: '开放标准，本地存储文件',
        message9: '智能设计工具+云服务平台',
        message10:
            '桌面、移动端高效设计，云服务提供海量设计资源，设计、施工与协同一体化、数字化',
        message11: '真实商品模型',
        message12: '供应商共赢模式，模型即商品，所见即所得，让业主更省心更放心',
        message13: '企业资产自主化',
        message14:
            '桌面端工具，本地存储文档，有效避免资产流失，提高资产复用率；存储格式开放，互联互通',
        message15: '全球流量红利',
        message16:
            '中国1.5亿用户都在用的PDF编辑器及阅读器，家装施工图的首选阅读工具，触达海量客户',
        message17: '易学好用',
        message18: '·海量真实房源户型图，3D户型直接即用',
        message19: '· 导入CAD/图片格式平面图，秒速生成可视化3D效果',
        message20: '·保留CAD操作习惯，易学易用',
        message21: '丰富铺法',
        message22: '丰富材质',
        message23: '造型多变',
        message24: '智能铺贴',
        message25: '·海量真实材质贴图库即搜即用',
        message26: '·独家优化算法，省工省料',
        message27: '·一键完成腰线、对缝、多区域复用',
        message28: '智能水电',
        message29: '回路',
        message30: '智能点位',
        message31: '智能水电',
        message32: '·水电点位自动布置',
        message33: '·水电管线智能铺设',
        message34: '·内置点位布置和管线铺设方案，且可自定义',
        message35: '地暖盘管',
        message36: 'BIM设备',
        message37: '定制地暖',
        message38: '·地暖设备BIM化',
        message39: '·可自定义盘管铺设区域',
        message40: '·独家优化算法，省工省料',
        message41: '添加注释',
        message42: '添加标注',
        message43: '生成立面图',
        message44: '一键导出',
        message45: '图纸管理',
        message46:
            '· 一键生成平面图（原始/拆除/新建墙体图）、立面图、水电图（灯具布置图/开关布置图等）',
        message47: '· 支持二次编辑、图纸同步、图纸导出PDF/JPG',
        message48: '· 遵循房屋建筑室内装饰装修制图国家标准',
        message49: '福昕家装',
        message50: '智能设计',
        message51: ' 让设计更高效，让家装更省心',
        message52: '桌面高效设计引领者，半天掌握3D户型设计、渲染、分享获客',
        message53: '下载智能设计',
        message54: '福昕家装智能设计',
        message55: '福昕家装智能设计',
        message56: ' 携手数字化，共赴新征程',
        message57: '家装行业一体化解决方案',
        message58: '福昕家装智能设计',
        message59: '福昕家装智能设计',
        message60: '快速上手，高效设计',
        message61: '降低学习成本，所见即所得，让家居设计变得更加简单',
        message62: '福昕家装智能设计',
        message63: '双剑合璧，化解多方"信任危机"',
        message64: '福昕家装智能设计',
        message65: '施工图、施工进度点对点沟通，打通沟通壁垒',
        message66: '福昕家装智能设计',
        message67:
            '施工阶段，使用云服务·尊享版，减少施工图错漏、施工现场协调难题和返工，缩短项目交付时间，增强项目可控性。',
        message68: '了解云服务·尊享版',
        message69: '行业合作伙伴',
        message70: '一体化解决方案达成共赢',
        message71: '加入我们，一起颠覆家装设计新方向',
        message72: '下载试用',
        wall: '墙',
        door: '门',
        parts: '部品部件',
        version: '当前版本',
        message73: '吊顶设计',
        message74: '· 顶面支持自由绘制平面/回形/叠级/圆弧/圆形等造型吊顶',
        message75: '·全屋空间参数化适配',
        message76: '·线条/灯槽/灯带一键快速应用',
        message77: '自由绘制',
        message78: '灯槽一键生成',
        message79: '全屋定制',
        message80: '· 覆盖厨卫、衣柜、玄关等数十种常见定制柜类',
        message81: '· 调用企业库个性化模型资源，即调即用更方便',
        message82: '· 基于模型距墙尺寸算法的吸附，放置模型更高效',
        message82_1: '· 一键批量生成顶线/台面/脚线',
        message82_2: '· 支持全局替换核心部件模型和材质',
        message83: '操作高效',
        message84: '台面一键生成',
        message85: '极速渲染 卓越品质',
        message86: '自研渲染引擎，效果一键生成，满足多种场景下的出图需求',
        message87: '普通图',
        message88: '全景图 ',
        message89: '全景预览 ',
        message90: '高清大图 立等可取',
        message91: '拥有丰富的可视化模型、材质资源，落地效果轻松掌控',
        message92: '灵活布光',
        message93: '一键灯光布置，支持创建多种布光方案',
        message94: '快速出图',
        message95: '1分钟出2K图，渲染颠覆性提速',
        message96: '真实还原',
        message97: '最高8K渲染，还原商品形状、材质纹理等细节',
        message99: '产品总览',
        production1: '智能设计·桌面端',
        production2: '福昕智装·移动端',
        production3: '云服务·尊享版',
        production4: '云服务·企业版',
        productionDesc1: '随身必备的装修3D设计运营神器',
        productionDesc2: '智能化、BIM化室内设计软件',
        productionDesc3: '为品质家装提供个性化项目管理服务',
        productionDesc4: '数据赋能装企，专注项目生命周期管理',
        message105: '装配式吊顶',
        message100: '· 支持多种几何建模能力',
        message101: '· 解析CAD图形轮廓进行二次应用',
        message102: '· 使用参数配置造型的变化规则',
        message103: '· 随心自由拼搭造型',
        message104: '了解更多>',
        message107: 'AI设计',
        message108:
            '· 将优秀案例设定为样板间，再通过AI一键完成应用，极大提升设计效率',
        message109:
            '· 基于户型平面图的几何特征与空间布局特征双匹配的核心技术，AI智能匹配目标户型相似度较高的样板间，提升筛选效率，获得更好的布局体验。',
        message110: '算量报价',
        message111: '· 覆盖硬装、软装、定制、工程等业务场景',
        message112: '· 基于方案BIM数据自动生成工程量，杜绝错算、漏算',
        message113: '· 账号级工程量&报价记忆功能，自动带入历史数据',
    },
    landingPage: {
        message1: '尊享服务',
        message2: '告别杂乱无章，体验井然有序',
        message3: '高效协作',
        message4: '支持多项目角色+终端协作场景',
        message5: '规避风险',
        message6: '开完工提醒、待办事项实时通知',
        message7: '保质保量',
        message8: '过程可视化，巡检+验收保驾护航',
        message9: '精量图纸共享',
        message10: '一方上传资料，同步至相关联的多方，业主无需多次重复配合。',
        message11: '专人专项负责',
        message12:
            '在资料对应位置@对应的负责人进行问题的推进，不会分散无关人员的精力。',
        message13: '问题精准定位',
        message14:
            '在资料对应位置精准查看问题推进的过程和结果，不受其它无关问题的干扰。',
        message15: '结果实时通知',
        message16:
            '问题推进的过程和结果自动实时通知，若是理解不一致，可以及时纠偏。',
        message17: '进度计划跟踪',
        message18:
            '更加直观的进度计划表，对应位置跟踪和汇报对应问题，集中精力。',
        message19: '过程验收记录',
        message20: '对应计划对应验收记录，适时把控落地效果。',
        message21: '避免过程风险',
        message22:
            '开/完工前自动实时通知，避免延期；工期变更业主签名，方便追溯避免扯皮。',
        message23: '黄小宝设计研究中心',
        message24: '福州十大设计公司',
        message25: '湖北·宜都西湖尚苑B区别墅',
        message26: '黄小宝设计研发中心｜四层别墅｜360㎡｜全包',
        message27: '集致空间',
        message28: '福州十大设计公司',
        message29: '金辉铂宫',
        message30: '福州集致空间装饰｜三室两厅｜136㎡｜全包',
        message31: '跟进体验差',
        message32:
            '采用“服务群+Excel”式的对接方式，记录难查找、文件易过期，解决进展难以掌握。',
        message33:
            '时间成本高，每天跟踪进度、材料验收等问题更是<br/>应接不暇。',
        message34:
            '供货商、施工方彼此之间各自为营，施工标准无法<br/>统一，重复性事务多效率低。',
        message35:
            '关联工序缺少关键材料影响后续施工计划，导致工<br/>期一再拖延。',
        message36:
            '厂商易忽略对施工人员新型材料和工艺的培训，落<br/>地效果大打折扣也无力挽回。',
        message37: '材料清单在施工中经常被推荐升级增项，费力超时<br/>还超支。',
        message38: '首月免费，次月起88元/月',
        message39: '为品质家装提供个性化的项目管理服务',
        message40: '福昕家装',
        message41: '福昕家装云服务',
        message42: '立即体验',
        message43: '福昕家装',
        message44: '福昕家装云服务',
        message45: '福昕家装',
        message46: '福昕家装云服务',
        message47: '传统家装业主',
        message48: '大不满上榜理由',
        message49: '福昕家装',
        message50: '福昕家装云服务',
        message51: '传统群聊+Excel工作方式',
        message52: '福昕家装云服务-尊享版',
        message53: '每月不足百元 给他百般呵护',
        message54: '让他百倍满意 赢取百次口碑',
        message55: '福昕家装',
        message56: '福昕家装云服务',
        message57: '施工图纸协作',
        message58: '高效沟通·实时共享',
        message59: '福昕家装',
        message60: '福昕家装云服务',
        message61: '施工计划协作',
        message62: '科学施工·进度透明',
        message63: '福昕家装',
        message64: '福昕家装云服务',
        message65: '有口碑，自然能听见回响',
        message66: '福昕家装',
        message67: '福昕家装云服务',
        message68: '福昕家装',
        message69: '一对一服务',
        message70: '福昕家装·产业链生态合作伙伴',
        message71: '联系我们',
        message72: '价值999元一对多培训',
        message73: '免费赠送优质设计方案',
        message74: '提交成功，我们将尽快与您联系，请注意接听电话。',
        inputName: '请输入姓名',
        tooLongTime: '跟踪耗时长',
        collaborate: '多方协作难',
        overTime: '工期常超时',
        toManyProblem: '新材料问题多',
        expenditure: '严重超预算',
    },
};
